export default {
    'hostApp': 'https://app.applicolis.com',
    'hostApi': 'https://app.applicolis.com/admin-api/',
    'mapboxToken': 'pk.eyJ1IjoiYXBwbGljb2xpcyIsImEiOiJja3AwN3BhYXgwa3FuMnBuejk3c3lqb29hIn0.6Y8iupy_r1kzM8DJ_DueKA'
}